import SearchForm from '../Form/Form';
import sideImage from './dmv-lg.jpg';
function Landing(){
    return(
        <main className="h-full" >
            <div className="h-full relative dark:bg-gray-900">
                <div className="h-80 absolute inset-x-0 bottom-0 xl:top-0 xl:h-full">
                    <div className="h-full w-full xl:grid xl:grid-cols-2">
                        <div className="h-full xl:relative xl:col-start-2">
                            <img
                                className="h-full w-full object-cover xl:absolute xl:inset-0 opacity-100 bg-gray-900 dark:opacity-25"
                                src={sideImage}
                                alt="nebraska landscape with road"/>
                            {/* <div aria-hidden="true" classNameName="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900 xl:inset-y-0 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r"/> */}
                        </div>
                    </div>
                </div>
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8">
                    <div className="relative pb-64 sm:pt-24 md:pb-24 xl:col-start-1 xl:pb-24">
                        <h2 className="mt-3 text-3xl font-extrabold text-blue-500 dark:text-white">
                            Nebraska DMV – Driver’s License/State ID Card Mailing Status Check
                        </h2>
                        <p></p>
                        <div>
                            <SearchForm/>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Landing;
